<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-selector-block e-selector-block--product">
          <template v-if="!isLoading">
            <div class="e-row e-row--gutters">
              <div class="e-col e-col-sm-12">
                <div class="e-block__title e-block__title--sm" v-if="!isMiniTank">For zip code: <span class="e-red">{{ selectedZip || '10001' }}</span> Eemax suggests these heaters:</div>
                <div class="e-block__title e-block__title--sm" v-if="isMiniTank">MiniTanks are an excellent Solution when only 120V is available! Choose your MiniTank:</div>
              </div>
              <div class="e-col-auto e-col-sm-12">
                <div class="e-block__info-icon" @click="toggleModal">Common household fixtures</div>
              </div>
            </div>
            <div class="e-product__slider">
              <div v-if="hasScroll && hasPrevBtn" @click="prev" class="e-product__btn e-product__btn--prev" :style="{height: `${itemHeight}px`}"></div>
              <div v-if="hasScroll && hasNextBtn" @click="next" class="e-product__btn e-product__btn--next" :style="{height: `${itemHeight}px`}"></div>
              <div class="e-product__scroll">
                <div class="e-product__wrap" ref="productBlock" :style="{transform: `translateX(${currentOffset}`}">
                  <div class="e-product" v-for="(product, index) in formattedProducts" :key="index">
                    <div class="e-product__img">
                      <img :src="product.img" :alt="product.model"/>
                    </div>
                    <div class="e-product__info">
                      <template v-if="!isMiniTank">
                        <div class="e-product__param">
                          <div class="e-product__label">{{ index === currentItem - 1 || isMobile ? 'Model' : '&nbsp;'}}</div>
                          <div class="e-product__value" v-html="product.model"></div>
                        </div>
                        <div class="e-product__param">
                          <div class="e-product__label">{{ index === currentItem - 1 || isMobile  ? 'Maximum flow rate' : '&nbsp;'}}</div>
                          <div class="e-product__value">{{ product.flowRate }} GPM</div>
                        </div>
                        <div class="e-product__param" v-if="product.AmperageText">
                          <div class="e-product__label">{{ index === currentItem - 1 || isMobile  ? 'Max. amperage pull' : '&nbsp;'}}</div>
                          <div class="e-product__value">{{ product.AmperageText }} Amps</div>
                        </div>
                        <div class="e-product__param" v-if="product.panelSize">
                          <div class="e-product__label">{{ index === currentItem - 1 || isMobile  ? 'Min. circuit breaker panel size' : '&nbsp;'}}</div>
                          <div class="e-product__value">{{ product.panelSize }} Amps</div>
                        </div>
                      </template>
                      <template v-if="isMiniTank">
                        <div class="e-product__param">
                          <div class="e-product__label">{{ index === currentItem - 1 || isMobile ? 'Model & Volume' : '&nbsp;'}}</div>
                          <div class="e-product__value" v-html="product.ModelSKU"></div>
                        </div>
                        <div class="e-product__param" v-if="product.capacity">
                          <div class="e-product__label">{{ index === currentItem - 1 || isMobile  ? 'Storage Capacity' : '&nbsp;'}}</div>
                          <div class="e-product__value">{{ product.capacity }} Gal.</div>
                        </div>
                        <div class="e-product__param" v-if="product.dimensions">
                          <div class="e-product__label">{{ index === currentItem - 1 || isMobile  ? 'Dimensions' : '&nbsp;'}}</div>
                          <div class="e-product__value">{{ product.dimensions }}</div>
                        </div>
                      </template>
                      <div class="e-product__param">
                        <div class="e-product__label">{{ index === currentItem - 1 || isMobile ? 'Quantity' : '&nbsp;'}}</div>
                        <div class="e-product__value">
                          <div class="e-row e-row--justify-center">
                            <div class="e-col-auto">
                              <div class="e-product__quantity e-product__quantity--decrease" @click="decrease(product)"></div>
                            </div>
                            <div class="e-col-auto">
                              <div class="e-product__quantity-value">{{ product.quantity }}</div>
                            </div>
                            <div class="e-col-auto">
                              <div class="e-product__quantity e-product__quantity--increase" @click="increase(product)"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div v-else>
            <loader-screen/>
          </div>
        </div>
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row e-row--gutters">
        <div class="e-col-auto e-col-sm-6 e-order-sm-2">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
        <div class="e-col-auto e-col-sm-6 e-order-sm-3">
          <button class="e-btn e-btn--help e-btn--no-text" @click.prevent="nextQuestion(needHelp)"><span>Help</span></button>
        </div>
        <div class="e-col"></div>
        <div class="e-col-auto e-col-sm-12 e-order-sm-1">
          <button class="e-btn e-btn--next" @click.prevent="proceed()" :disabled="isLoading || btnDisabled">Proceed</button>
        </div>
      </div>
    </div>
    <common-fixtures @modal-close="toggleModal" :open="modalIsOpen"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { needHelp } from '@/utils/residential-flow';
import LoaderScreen from '@/components/ui/LoaderScreen.vue';
import CommonFixtures from '@/components/ui/CommonFixtures.vue';

// @TODO decomposition into several components is required
export default {
  components: {
    LoaderScreen,
    CommonFixtures,
  },
  name: 'HeaterChoice',
  data() {
    return {
      needHelp,
      itemsOnDesktop: 4,
      currentItem: 1,
      itemWidth: 0,
      itemHeight: 0,
      modalIsOpen: false,
    };
  },
  created() {
    this.clearProducts();
  },
  mounted() {
    this.getProducts(false);
  },
  computed: {
    ...mapState(['selectedFlow', 'selectedZip', 'isMobile', 'products', 'containerHeight']),
    ...mapGetters(['currentQuestion', 'filter']),
    formattedProducts() {
      return this.products.map((product) => ({
        ...product,
        flowRate: ((+(product.Kilowatts) * 6.83) / (this.filter['temp-out'] - this.filter['temp-in'])).toFixed(2),
        panelSize: this.getPanelSize(product.Kilowatts),
      }));
    },
    countProducts() {
      return this.products.length;
    },
    hasScroll() {
      return !this.isMobile && this.countProducts > this.itemsOnDesktop;
    },
    currentOffset() {
      this.getItemSize();
      const offset = this.itemWidth * (this.currentItem - 1);
      return `-${offset}px`;
    },
    hasNextBtn() {
      return this.currentItem <= this.countProducts - this.itemsOnDesktop;
    },
    hasPrevBtn() {
      return this.currentItem > 1;
    },
    isMiniTank() {
      return this.filter && +(this.filter?.volts) === 120;
    },
    isLoading() {
      return this.countProducts === 0;
    },
    btnDisabled() {
      return this.products.reduce((a, c) => (a + c.quantity), 0) === 0;
    },
  },
  methods: {
    ...mapActions(['previousQuestion', 'nextQuestion', 'addParamToFilter', 'getProducts', 'clearProducts', 'changeProductQuantity']),
    previous() {
      this.previousQuestion();
    },
    proceed() {
      this.nextQuestion(this.currentQuestion.nextId);
    },
    decrease(product) {
      if (product.quantity > 0) {
        const quantity = product.quantity - 1;
        this.changeProductQuantity({ ModelID: product.ModelID, quantity });
      }
    },
    increase(product) {
      const quantity = product.quantity + 1;
      this.changeProductQuantity({ ModelID: product.ModelID, quantity });
    },
    next() {
      if (this.hasNextBtn) {
        this.currentItem += 1;
      }
    },
    prev() {
      if (this.hasPrevBtn) {
        this.currentItem -= 1;
      }
    },
    getItemSize() {
      this.itemWidth = this.$refs.productBlock ? (this.$refs.productBlock.offsetWidth / this.itemsOnDesktop) : 0;
      this.itemHeight = this.$refs.productBlock ? (this.$refs.productBlock.offsetHeight - 9) : 0;
    },
    toggleModal() {
      this.modalIsOpen = !this.modalIsOpen;
    },
    getPanelSize(kw) {
      if (kw <= 13) {
        return 125;
      }
      if (kw > 13 && kw <= 18) {
        return 150;
      }
      if (kw > 18 && kw <= 27) {
        return 200;
      }
      return 300;
    },
  },
  watch: {
    products() {
      setTimeout(() => {
        this.getItemSize();
      }, 0);
    },
  },
};
</script>

<style lang="scss">

</style>
